import { getGamePath } from '@/shared/libs/get-game-path';

export function getGamePlayPath(
  game?: Parameters<typeof getGamePath>[0]
): string {
  return `${getGamePath(game)}/play`;
}
